// import Head from "next/head";
import React from 'react';

export default function SeoHead({ seoObject, content }) {
  const logo = '../../../../assets/icon.png';
  return (
    <head>
      <title>{content?.name}</title>
      <meta name="description" content={`${content?.description}`} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href={logo} />
    </head>
  );
}
